import { captureException } from '@sentry/react'

export const handleError = error => {
	let toCapture = error
	if (!(error instanceof Error)) {
		const message =
			error && error.message ? error.message : JSON.stringify(error)
		toCapture = new Error(message)
		toCapture.originalError = error
	}
	captureException(toCapture)
}
